import app from 'firebase/app';
import { getUserByUid } from './users';
import { USER } from '../../constants/roles';
import { convertDateToFirestoreTimestamp } from './firestoreUtils';

export const doSignInWithEmailAndPassword = (email, password) =>
    app.auth().signInWithEmailAndPassword(email, password);

export const onAuthUserListener = (next, fallback) =>
    app.auth().onAuthStateChanged(authUser => {
        if (authUser) {
            getUserByUid(authUser.uid).then(snapshot => {
                // merge auth and db user
                authUser = {
                    uid: authUser.uid,
                    firstName: snapshot && snapshot.firstName ? snapshot.firstName : '',
                    lastName: snapshot && snapshot.lastName ? snapshot.lastName : '',
                    email: authUser.email,
                    emailVerified: authUser.emailVerified,
                    inviteCode: snapshot ? snapshot.inviteCode : '',
                    stripeUserId: snapshot ? snapshot.stripeUserId : '',
                    acceptPolicy:
                        snapshot && snapshot.acceptPolicy ? Boolean(snapshot.acceptPolicy) : false,
                    role: snapshot && snapshot.role ? snapshot.role : USER,
                    pendingPayments:
                        snapshot && snapshot.pendingPayments ? snapshot.pendingPayments : [],
                    earned: snapshot && snapshot.earned ? snapshot.earned : 0,
                    donated: snapshot && snapshot.donated ? snapshot.donated : 0,
                    position: snapshot && snapshot.position ? snapshot.position : '',
                    myPostsLastCheckTimestamp:
                        snapshot && snapshot.myPostsLastCheckTimestamp
                            ? snapshot.myPostsLastCheckTimestamp
                            : convertDateToFirestoreTimestamp(new Date()),
                    alreadySeeWelcomePopup: snapshot && snapshot.alreadySeeWelcomePopup,
                };
                next(authUser);
            });
        } else {
            fallback();
        }
    });

export const onSessionSyncListner = next => {
    const authUser = app.auth().currentUser;
    if (authUser) {
        getUserByUid(authUser.uid).then(snapshot => {
            // merge auth and db user
            const sessionUser = {
                uid: authUser.uid,
                email: authUser.email,
                emailVerified: authUser.emailVerified,
                acceptPolicy: snapshot.acceptPolicy,
                role: snapshot.role,
                inviteCode: authUser.inviteCode,
                stripeUserId: authUser.stripeUserId ? authUser.stripeUserId : '',
                myPostsLastCheckTimestamp: snapshot.myPostsLastCheckTimestamp,
                pendingPayments: authUser.pendingPayments ? authUser.pendingPayments : [],
                earned: authUser.earned ? authUser.earned : 0,
                donated: authUser.donated ? authUser.donated : 0,
            };
            next(sessionUser);
        });
    }
};

export const reauthenticate = currentPassword => {
    const user = app.auth().currentUser;
    const cred = app.auth.EmailAuthProvider.credential(user.email, currentPassword);
    return user.reauthenticateAndRetrieveDataWithCredential(cred);
};

export const doCreateUserWithEmailAndPassword = (email, password) =>
    app.auth().createUserWithEmailAndPassword(email, password);

export const doSignOut = () => app.auth().signOut();

export const doPasswordReset = email => app.auth().sendPasswordResetEmail(email);

export const doPasswordUpdate = password => app.auth().currentUser.updatePassword(password);

export const doEmailUpdate = email => app.auth().currentUser.updateEmail(email);

export const doSendEmailVerification = () =>
    app.auth().currentUser.sendEmailVerification({
        url: process.env.REACT_APP_CONFIRMATION_EMAIL_REDIRECT,
    });

export const resetPassword = email => {
    return app.auth().sendPasswordResetEmail(email);
};
